<template>
  <el-row :gutter="10" v-if="checkData()" :class="getStyle()">
    <el-col :xs="24" :sm="24" :md="8" :lg="4">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Transactions</span>
          <span class="right-header">Success/Failed</span>
        </div>
        <div>
          <table class="summary-table">
            <tr>
              <th>GBP</th>
              <td>{{ data.transaction.gbp }}</td>
            </tr>
            <tr>
              <th>EUR</th>
              <td>{{ data.transaction.eur }}</td>
            </tr>
          </table>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="24" :sm="24" :md="8" :lg="4">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Volume</span>
        </div>
        <div>
          <table class="summary-table">
            <tr>
              <th>GBP</th>
              <td>{{ formatNumber(data.volume.gbp) }}</td>
            </tr>
            <tr>
              <th>EUR</th>
              <td>{{ formatNumber(data.volume.eur) }}</td>
            </tr>
          </table>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="24" :sm="24" :md="8" :lg="4">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Failed</span>
        </div>
        <div>
          <table class="summary-table">
            <tr>
              <th>GBP</th>
              <td>{{ formatNumber(data.failedVolume.gbp) }}</td>
            </tr>
            <tr>
              <th>EUR</th>
              <td>{{ formatNumber(data.failedVolume.eur) }}</td>
            </tr>
          </table>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="24" :sm="24" :md="8" :lg="4">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Settle fund</span>
        </div>
        <div>
          <table class="summary-table">
            <tr>
              <th>GBP</th>
              <td>{{ formatNumber(data.settlefund.gbp) }}</td>
            </tr>
            <tr>
              <th>EUR</th>
              <td>{{ formatNumber(data.settlefund.eur) }}</td>
            </tr>
          </table>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="24" :sm="24" :md="8" :lg="4">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Paid</span>
        </div>
        <div>
          <table class="summary-table">
            <tr>
              <th>GBP</th>
              <td>{{ formatNumber(data.paid.gbp) }}</td>
            </tr>
            <tr>
              <th>EUR</th>
              <td>{{ formatNumber(data.paid.eur) }}</td>
            </tr>
          </table>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="24" :sm="24" :md="8" :lg="4">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Unpaid</span>
        </div>
        <div>
          <table class="summary-table">
            <tr>
              <th>GBP</th>
              <td>{{ formatNumber(data.unpaid.gbp) }}</td>
            </tr>
            <tr>
              <th>EUR</th>
              <td>{{ formatNumber(data.unpaid.eur) }}</td>
            </tr>
          </table>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import utility from "@/components/utility";
export default {
  props: {
    data:Object,
    viewSize: String
  },
  data() {

    return {
      
    };
  },
  methods: {
    formatNumber(num) {
      return utility.currencyFormat(num);
    },
    checkData(){
      if(this.data.volume && this.data.transaction && this.data.settlefund && this.data.paid && this.data.unpaid && this.data.failedVolume){
        return true
      }

      return false
    },
    getStyle(){
      if(this.viewSize && this.viewSize === 'small'){
        return "summary-view-small"
      }
      return "summary-view"
    }
  },
  created(){
    
  }
};
</script>

<style lang="scss">
.summary-view {
  .summary-all {
    float: right;
    font-size: 1.5rem;
    font-weight: bold;
  }
  .summary-table {
    width: 100%;

    th {
      text-align: left;
      width: 20%;
      color: #545c64;
      font-weight: 600;
    }

    td {
      text-align: right;
      font-size: 16px;
      font-weight: 900;
    }
  }
}

.summary-view-small {
  .el-card__header {
    padding: 5px 10px;
  }
  .el-card__body{
    padding: 5px 10px;
    font-size: 14px;
  }
  .summary-all {
    float: right;
    font-size: 1.2rem;
    font-weight: bold;
  }
  .summary-table {
    width: 100%;

    th {
      text-align: left;
      width: 20%;
      color: #545c64;
      font-weight: 600;
      text-align: left;
    }

    td {
      text-align: right;
      font-weight: 900;
    }
  }
  .right-header{
    float: right;
    font-size: 12px;
    line-height: 24px;
  }
}
</style>